// Performance Monitoring for Core Web Vitals
type PerformanceEntryWithInput = PerformanceEntry & {
  processingStart?: number;
  hadRecentInput?: boolean;
  value?: number;
};

type NavigationEntryLike = PerformanceEntry & {
  loadEventEnd: number;
  fetchStart: number;
};

export function monitorPerformance(): void {
  if (typeof window === 'undefined') return;

  // Monitor Largest Contentful Paint (LCP)
  function observeLCP() {
    if ('PerformanceObserver' in window) {
      const observer = new PerformanceObserver((list) => {
        const entries = list.getEntries();
        const lastEntry = entries[entries.length - 1];

        // LCP should be under 2.5s
        if (lastEntry.startTime > 2500) {
          // above threshold - no action needed in production
        }
      });

      observer.observe({ entryTypes: ['largest-contentful-paint'] });
    }
  }

  // Monitor First Input Delay (FID)
  function observeFID() {
    if ('PerformanceObserver' in window) {
      const observer = new PerformanceObserver((list) => {
        const entries = list.getEntries();
        entries.forEach((entry) => {
          // FID should be under 100ms
          const typedEntry = entry as PerformanceEntryWithInput;
          const fid = (typedEntry.processingStart ?? typedEntry.startTime) - typedEntry.startTime;
          if (fid > 100) {
            // above threshold - no action needed in production
          }
        });
      });

      observer.observe({ entryTypes: ['first-input'] });
    }
  }

  // Monitor Cumulative Layout Shift (CLS)
  function observeCLS() {
    if ('PerformanceObserver' in window) {
      let clsValue = 0;
      const observer = new PerformanceObserver((list) => {
        const entries = list.getEntries();
        entries.forEach((entry) => {
          const typedEntry = entry as PerformanceEntryWithInput;
          if (!typedEntry.hadRecentInput) {
            clsValue += typedEntry.value ?? 0;
          }
        });

        // CLS should be under 0.1
        if (clsValue > 0.1) {
          // above threshold - no action needed in production
        }
      });

      observer.observe({ entryTypes: ['layout-shift'] });
    }
  }

  // Monitor page load performance
  function monitorPageLoad() {
    window.addEventListener('load', () => {
      setTimeout(() => {
        const navigation = performance.getEntriesByType('navigation')[0] as NavigationEntryLike | undefined;
        if (navigation) {
          // Check if load time is under 3 seconds
          const totalLoadTime = navigation.loadEventEnd - navigation.fetchStart;
          if (totalLoadTime > 3000) {
            // above threshold - no action needed in production
          }
        }
      }, 0);
    });
  }

  // Initialize all monitoring
  observeLCP();
  observeFID();
  observeCLS();
  monitorPageLoad();
}

// Auto-initialize when imported
if (typeof window !== 'undefined') {
  monitorPerformance();
}

